(() => {
  function init(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const hero = root.querySelector('.ks-fe-hero-image');
    const dialog = root.querySelector('[data-ks-fe-dialog]');
    root.querySelectorAll('[data-ks-fe-image]').forEach(button => {
      button.addEventListener('click', () => {
        hero.removeAttribute('srcset');
        hero.src = button.dataset.ksFeImage;
        hero.alt = button.dataset.ksFeAlt || '';
        root.querySelectorAll('[data-ks-fe-image]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      });
    });
    root.querySelector('[data-ks-fe-zoom]')?.addEventListener('click', () => {
      const image = dialog.querySelector('img');
      image.removeAttribute('srcset');
      image.src = hero.currentSrc || hero.src;
      image.alt = hero.alt;
      dialog.showModal();
    });
    root.querySelector('[data-ks-fe-gift-zoom]')?.addEventListener('click', event => {
      const source = event.currentTarget.querySelector('img');
      const image = dialog.querySelector('img');
      image.removeAttribute('srcset');
      image.src = source.currentSrc || source.src;
      image.alt = source.alt;
      dialog.showModal();
    });
    root.querySelector('[data-ks-fe-close]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    const form = root.querySelector('.ks-fe-form');
    const offer = root.querySelector('four-pillars-offer');
    const sticky = root.querySelector('[data-ks-fe-sticky]');
    const mainButton = form.querySelector('[name="add"]');
    root.querySelector('[data-ks-fe-sticky-add]')?.addEventListener('click', () => {
      if (!mainButton.disabled) form.requestSubmit(mainButton);
    });
    const syncPrice = () => {
      const total = offer?.querySelector('[data-offer-total]')?.textContent;
      if (!total) return;
      root.querySelectorAll('[data-ks-fe-button-total],[data-ks-fe-sticky-total]').forEach(element => { element.textContent = total; });
    };
    if (offer) {
      const priceObserver = new MutationObserver(syncPrice);
      priceObserver.observe(offer.querySelector('[data-offer-total]'), { childList: true, characterData: true, subtree: true });
      syncPrice();
    }
    const selectionButton = root.querySelector('[data-selection-submit]');
    const syncSticky = () => {
      const bounds = selectionButton?.getBoundingClientRect();
      const selectionVisible = bounds && bounds.top >= 0 && bounds.bottom <= window.innerHeight;
      sticky.hidden = mainButton.getBoundingClientRect().bottom > 0 || selectionVisible;
    };
    let scrollFrame = 0;
    window.addEventListener('scroll', () => {
      cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(syncSticky);
    }, { passive: true });
    window.addEventListener('resize', syncSticky);
    const observer = new IntersectionObserver(syncSticky, { threshold: 0 });
    observer.observe(mainButton);
    if (selectionButton) observer.observe(selectionButton);
    syncSticky();
    new MutationObserver(() => { root.querySelector('[data-ks-fe-sticky-add]').disabled = mainButton.disabled; }).observe(mainButton, { attributes: true, attributeFilter: ['disabled'] });

  }
  document.querySelectorAll('[data-ks-fe-landing]').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-ks-fe-landing]')));
})();

